import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { clsx } from 'clsx';
import * as React from 'react';
/**
 * Input component for auth forms
 * Styled consistently with the design system
 */
export const AuthInput = React.forwardRef(({ className, label, error, helperText, id, ...props }, ref) => {
    const inputId = id || `auth-input-${React.useId()}`;
    const hasError = Boolean(error);
    return (_jsxs("div", { className: clsx('auth-input-wrapper', className), children: [label && (_jsx("label", { htmlFor: inputId, className: "auth-input-label", children: label })), _jsx("input", { ref: ref, id: inputId, className: clsx('auth-input', { 'auth-input--error': hasError }), "aria-invalid": hasError, "aria-describedby": error ? `${inputId}-error` : helperText ? `${inputId}-helper` : undefined, ...props }), error && (_jsx("span", { id: `${inputId}-error`, className: "auth-input-error", role: "alert", children: error })), helperText && !error && (_jsx("span", { id: `${inputId}-helper`, className: "auth-input-helper", children: helperText }))] }));
});
AuthInput.displayName = 'AuthInput';
//# sourceMappingURL=AuthInput.js.map